import 'bootstrap/js/dist/alert';
import $ from 'jquery';

export const Alert = {
    functional: true,
    props: {
        type: {
            type: String,
            default: 'primary',
        },
    },
    render(h, {props: {type}, data, slots}) {
        return (
            <div class={`alert alert-${type}`} role="alert" {...data}>
                {slots().default}
            </div>
        );
    }
}

export const AlertDismissible = {
    props: {
        type: String,
        animation: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        close: function () {
            $(this.$el).alert('close');
        },
    },
    mounted() {
        $(this.$el)
            .on('close.bs.alert', (event) => this.$emit('close', event))
            .on('closed.bs.alert', (event) => this.$emit('closed', event))
            .alert();
    },
    render(h) {
        return (
            <Alert
                type={this.type}
                class={[
                    'alert-dismissible',
                    (this.animation ? 'fade show' : null)
                ]}
            >
                {this.$slots.default}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </Alert>
        );
    }
}
